import Scrollbar from 'smooth-scrollbar';

import BezierEasing from 'bezier-easing';

import gsap from 'gsap';

import url from 'url';

import Component from '../base/component';
import { data, qs, qsa, toggleClass, hasClass, byId } from '../base/dom-utils';
import { sortByData } from '../base/utils';
import Common from '../base/common';

const pageFramesIn = BezierEasing(0.31, 0.19, 0.16, 1);

class Services extends Component {

    constructor(el, opts) {
        super(el, opts);

        // this.$els.pag = qs(this.options.pag);
        // this.$els.pagItem = qsa(this.options.pagItem, this.$els.pag);
        this.$els.sections = qsa(this.options.sections, this.$el);

        this.$els.frames = qsa(this.options.frames, this.$el);
        this.$els.mainFrame = qs(this.options.mainFrame, this.$el);

        this.$els.scrollIco = byId(this.options.scrollIco);

        this._scrollbar = Scrollbar.init(qs('[data-scrollbar]'));

    }

    beforeInit() {

        gsap.set(this.$els.scrollIco, {
            y: -40,
            opacity: 0
        });

        // set by default the first one
        // if (this.$els.pagItem.length) {
        //     const firstEl = this.$els.pagItem[0];
        //     toggleClass(firstEl, 'is-current', true);
        // }

        // this.delegate('click', this.options.pagItem, (e) => {
        //     e.preventDefault();
        //
        //     const target = e.target;
        //     const index = this.$els.pagItem.indexOf(target);
        //
        //     const sectionToScroll = this.$els.sections[index];
        //
        //     this._scrollbar.scrollIntoView(sectionToScroll);
        // });

        // this._scrollbar.addListener(() => {
        //
        //     this.$els.sections.forEach((elem) => {
        //
        //         if (this._scrollbar.isVisible(elem)) {
        //
        //             const sect = data('section', elem);
        //
        //             const currEl = this.$els.pagItem[sect - 1];
        //
        //             const prevEls = this.$els.pagItem.filter((el) => {
        //                 return hasClass(el, 'is-current');
        //             });
        //
        //             prevEls.forEach((el) => toggleClass(el, 'is-current', false));
        //
        //             toggleClass(currEl, 'is-current', true);
        //         }
        //
        //     });
        //
        // });

    }

    animationIn() {

        const enterTl = new TimelineMax({
            onComplete: () => this.parseUrlQuery()
        });

        const orderedFrames = sortByData(this.$els.frames);

        enterTl.staggerTo(orderedFrames.map((node) => node.children), 0.8, {
            y: 0,
            ease: new Ease(pageFramesIn)
        }, 0.25);

        if (Common.mq('s-tablet')) {

            enterTl.to(this.$els.mainFrame, 0.85, {
                y: 0,
                ease: new Ease(pageFramesIn)
            }, '-=0.4');

        }

        enterTl.to(this.$els.scrollIco, 0.5, {
            y: 0,
            opacity: 1
        });

    }

    parseUrlQuery() {

        const parsedUrl = url.parse(location.href, true);

        const queryObject = parsedUrl.query;

        const sectionIndex = parseInt(queryObject.service, 10);

        const sectionToScroll = this.$els.sections[sectionIndex - 1];

        this._scrollbar.scrollIntoView(sectionToScroll);
    }

    getDefaultOptions() {
        return {
            // pag: '.o-pag',
            // pagItem: '.o-pag__item',
            frames: '.o-text__frame',
            mainFrame: '#main-frame',
            sections: '[data-section]',
            scrollIco: 'scroll-down'
        };
    }

    destroy() {
        this._scrollbar.destroy();
        return super.destroy();
    }
}

export default Services;


/** WEBPACK FOOTER **
 ** ./containers/Services.js
 **/